// import cash from 'cash-dom'
// import TomSelect from 'tom-select'

// const setValue = (el, props) => {
//   if (props.modelValue != null) {
//     cash(el).val(props.modelValue)
//   }
// }

// const init = (el, emit, computedOptions) => {
//   el.TomSelect = new TomSelect(el, computedOptions)
//   el.TomSelect.on('change', function(selectedItems) {
//     emit('update:modelValue', selectedItems)
//   })
// }

// const reInit = (el, props, emit, computedOptions) => {
//   el.TomSelect.destroy()
//   cash(el).html(
//     cash(el)
//       .prev()
//       .html()
//   )
//   setValue(el, props)
//   init(el, emit, computedOptions)
// }

// export { setValue, init, reInit }
import cash from 'cash-dom'
import TomSelect from 'tom-select'

const normalizeValue = (modelValue) => {
  if (modelValue === null || modelValue === undefined || modelValue === '') {
    return []
  }

  if (Array.isArray(modelValue)) {
    return modelValue.map(String)
  }

  if (typeof modelValue === 'string' && modelValue.includes(',')) {
    return modelValue.split(',').map((value) => value.trim()).filter(Boolean)
  }

  return [String(modelValue)]
}

const getTomSelect = (el) => el?.tomselect || el?.TomSelect

const setValue = (el, props) => {
  const value = normalizeValue(props.modelValue)
  const tomSelect = getTomSelect(el)

  if (tomSelect) {
    tomSelect.setValue(value, true)
    return
  }

  if (value.length > 0) {
    cash(el).val(value)
  } else {
    cash(el).val([])
  }
}

const init = (el, emit, computedOptions) => {
  el.TomSelect = new TomSelect(el, computedOptions)
  el.TomSelect.on('change', function(selectedItems) {
    emit(
      'update:modelValue',
      el.multiple ? [...el.TomSelect.items] : selectedItems
    )
  })
}

const reInit = (el, props, emit, computedOptions) => {
  const tomSelect = getTomSelect(el)

  if (!el || !tomSelect) return

  tomSelect.destroy()
  cash(el).html(
    cash(el)
      .prev()
      .html()
  )
  init(el, emit, computedOptions)
  setValue(el, props)
}

export { setValue, init, reInit }
